import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import navPage from '../views/navPage.vue'
import searchPage from '../views/searchPage.vue'
import systemDemo from '../views/systemDemo.vue'
import designScheme from '../views/designScheme.vue'
import publicPictures from '../views/publicPictures.vue'
import videoDemo from '../views/videoDemo.vue'
import otherDemo from '../views/otherDemo.vue'
import infoPage from '../views/infoPage.vue'
import myCenter from "../views/myCenter.vue"
import paySuccess from "../views/paySuccess.vue"

Vue.use(VueRouter)

const routes = [
    //支付成功
    // {
    //   path: '/',
    //   name: 'paySuccess',
    //   component: paySuccess
    // }
  //首页目录
  {
    path: '/',
    name: 'index',
    component: index,

  },
  //1+2主要产业
  {
    path: '/navPage',
    name: 'navPage',
    component: navPage,
    redirect: "/navPage",
    //重定向到第一个子路由
    children: [{
      path: '/navPage',
      name: 'searchPage',
      component: searchPage,
    },
    {
      path: '/systemDemo',
      name: 'systemDemo',
      component: systemDemo,
    }, {
      path: '/designScheme',
      name: 'designScheme',
      component: designScheme,
    },
    {
      path: '/publicPictures',
      name: 'publicPictures',
      component: publicPictures,
    },
    {
      path: '/videoDemo',
      name: 'videoDemo',
      component: videoDemo,
    },
    {
      path: '/otherDemo',
      name: 'otherDemo',
      component: otherDemo,
    },
    {
      path: '/infoPage',
      name: 'infoPage',
      component: infoPage,
    },
    {
      path: '/myCenter',
      name: 'myCenter',
      component: myCenter,
    },   
    ]
  }
]


const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
